export const AUTH_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  APP_TOKEN: 'appToken',
  TPA_TOKEN: 'tpaToken',
  REFRESH_TOKEN: 'refreshToken',
  EXPIRY_TIME: 'expiryTime',
  VAPISTXID: 'vapistxId',
  SESSIONID: 'sessionId',
  RESET_REQUEST_ID: 'requestId',
  RESET_TOKEN: 'resetToken',
};

export const USER_DETAILS = {
  USERNAME: 'USERNAME',
  FULL_NAME: 'FULL_NAME',
  LOGIN_TYPE: 'LOGIN_TYPE',
  USER_ID: 'USER_ID',
  USER_SEQ_ID: 'USER_SEQ_ID',
  LEGAGY_USER_SEQ_ID: 'LEGAGY_USER_SEQ_ID',
  GROUP_ID: 'GROUP_ID',
  TOTAL_POLICIES: 'TOTAL_POLICIES',
  IS_SSO: 'IS_SSO',
  SOURCE_TYPE: 'SOURCE_TYPE',
};

export const USER_DATA = {
  DOB: 'DOB',
  GENDER: 'GENDER',
  EMAIL: 'EMAIL',
  GROUP_ID: 'GROUP_ID',
  CORPORATE_ID: 'CORPORATE_ID',
  MOBILE: 'MOBILE',
  NAME: 'NAME',
  WHATSAPP_CONSENT: 'WHATSAPP_CONSENT',
  OPD_POLICY_SOURCE: 'OPD_POLICY_SOURCE',
  WELLNESS_POLICY_SOURCEL: 'WELLNESS_POLICY_SOURCE',
  USER_SLUG: 'USER_SLUG',
  PATIENT_SLUG: 'PATIENT_SLUG',
  COLORS: 'COLORS',
  USER_ID: 'USER_ID',
  USER_TYPE: 'USER_TYPE',
  FINANCIAL_YEARS: 'FINANCIAL_YEARS',
  CONTACT_NAME: 'CONTACT_NAME',
  CONTACT_SEQ_ID: 'CONTACT_SEQ_ID',
  GROUP_NAME: 'GROUP_NAME',
  GROUP_REG_SEQ_ID: 'GROUP_REG_SEQ_ID',
  ROLE_NAME: 'ROLE_NAME',
  ASSIGNED_CITIES: 'ASSIGNED_CITIES',
};
